import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/">Casino Journal</Link>
      </div>
      {user && (
        <>
          <div className="navbar-links">
            <Link to="/" className={isActive('/') ? 'active' : ''}>
              Dashboard
            </Link>
            <Link to="/transactions" className={isActive('/transactions') ? 'active' : ''}>
              Transaktionen
            </Link>
            <Link to="/casinos" className={isActive('/casinos') ? 'active' : ''}>
              Casinos
            </Link>
            <Link to="/statistics" className={isActive('/statistics') ? 'active' : ''}>
              Statistiken
            </Link>
            <Link to="/bonushunts" className={isActive('/bonushunts') ? 'active' : ''}>
              Bonushunts
            </Link>
            <Link to="/bigwins" className={isActive('/bigwins') ? 'active' : ''}>
              Big Wins
            </Link>
          </div>
          <div className="navbar-user">
            <span>Hallo, {user.username}</span>
            <button onClick={handleLogout} className="btn-logout">
              Abmelden
            </button>
          </div>
        </>
      )}
    </nav>
  );
};

export default Navbar;
